import { render } from "./DeskAndHours.vue?vue&type=template&id=f133a2d2"
import script from "./DeskAndHours.vue?vue&type=script&lang=js"
export * from "./DeskAndHours.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__